import Swal from "sweetalert2";
import AXIOS from "../../config/axios";

const deleteLocker = async (id) => {
  try {
    const res = await AXIOS.delete(`/lockers/delete/${id}`);
    return res.data;
  } catch (error) {
    console.log(error);
    Swal.fire(error.message);
  }
};
export default deleteLocker;
